import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import classnames from 'classnames'

import { isDescendant } from "../../utils/DomHelper"
import WindowEventHelper from "../../lib/WindowEventHelper";

class TSelectFilter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            selectedIndex: props.items.findIndex(item => item.value == props.selected)
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedIndex: nextProps.items.findIndex(item => item.value == nextProps.selected)
        })
    }

    shouldComponentUpdate(nextProps, nextState){

        if(JSON.stringify(this.props) !== JSON.stringify(nextProps) || JSON.stringify(this.state) !== JSON.stringify(nextState)){
            return true;
        }else {
            return false;
        }
    }

    componentWillUnmount() {

        const { open } = this.state;
        if(open) {
            WindowEventHelper.remove("click", this.handleWindowClick)
        }
    }

    componentDidUpdate() {
        const { selectedIndex } = this.state
        const { layer } = this.refs

        if (selectedIndex < 0) {
            return;
        }

        layer.scrollTop = layer.children[selectedIndex].offsetTop
    }

    @autobind
    handleWindowClick(e) {
        const { root } = this.refs
        let target = e.target

        if (!isDescendant(root, target)) {
            this.handleClose()
        }
    }

    @autobind
    handleClose() {
        const { onBlur } = this.props
        if (onBlur) {
            onBlur()
        }
        this.setState({
            open: false
        });

        WindowEventHelper.remove("click", this.handleWindowClick)
    }

    @autobind
    handleOpen() {
        const { onFocus } = this.props
        if (onFocus) {
            onFocus()
        }
        this.setState({
            open: true
        });

        WindowEventHelper.add("click", this.handleWindowClick);
    }

    @autobind
    handleToggleOpen(e) {
        const { open } = this.state;
        if (open) {
            this.handleClose()
        } else {
            this.handleOpen()
        }
    }

    @autobind
    handleSelect(item, idx) {
        const { onSelect } = this.props

        this.handleClose()
        if (this.props.items[this.state.selectedIndex] != item){
            onSelect(item, idx)
        }
    }

    render() {
        const { name, className, items, disabled} = this.props;
        const { open, selectedIndex } = this.state;

        let selectedItem = selectedIndex < 0 ? items[0] : items[selectedIndex]

        return (
            <div ref="root" className={className}>
                <div className={classnames('opt_set', {'opt_open':open})}>
                    <button type="button" className="btn_opt" onClick={this.handleToggleOpen} disabled={disabled}>
                        <span className="txt_ellip">{ selectedItem.label }</span>
                        <span className="ico_blog ico_open"/>
                    </button>
                    <div ref="layer" className="layer_opt">
                        { items.map((item, idx) =>
                            <label key={idx} className={ classnames("lab_set", {"on": idx === selectedIndex})}>
                                <input type="radio" name={name} className="inp_set" defaultValue={item.value}
                                       onClick={e => this.handleSelect(item, idx)}/>
                                <span className="txt_set txt_ellip">{item.label}</span>
                            </label>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

TSelectFilter.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    items: PropTypes.array.isRequired,
    selected: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
}

export default TSelectFilter
